module.exports = __webpack_public_path__ + "img/3_5.22c7b6bd.png";